import { Typography } from '@mui/material';
import { FC } from 'react';

import { Job } from 'domain/entities/GetJobResponse';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { TextField } from 'targets/web/components';

import { Container } from './common';

export interface CloseoutJobDetailsProps {
  job: Job;
}

export const CloseoutJobDetails: FC<CloseoutJobDetailsProps> = ({ job }) => {
  const t = useTranslationPrefix('jobs.details_form.closeout_details');

  return (
    <Container gap={4} sx={{ padding: 4 }}>
      <Typography variant="h6">{t('title')}</Typography>
      <TextField
        label={t('security_seal_label')}
        name="securitySealNumber"
        value={job.securitySealNumber ?? ''}
        fullWidth
        readOnly
      />
      <TextField
        label={t('closeout_notes_label')}
        name="closeoutNotes"
        value={job.closeoutNotes ?? ''}
        fullWidth
        multiline
        rows={4}
        readOnly
      />
    </Container>
  );
};
